//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { MdClose } from 'react-icons/md';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------

//------------------------------------------------------------------------------
// Styles ----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class ModalBase extends React.Component {
  constructor(props) {
    super(props);
    this.escfunction = this.escfunction.bind(this);
    this.modalContext = React.createContext();
  }
  escfunction(event) {
    if (event.keyCode === 27) {
      {
        this.props.onClose();
      }
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escfunction, false);
    document.body.style.overflow = 'hidden';
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escfunction, false);
    document.body.style.overflow = null;
  }

  componentDidUpdate(prevProps) {
    const { visible, modalDidOpen, modalDidClose } = this.props;

    if (visible && prevProps.visible !== visible && modalDidOpen) {
      modalDidOpen();
    } else if (!visible && prevProps.visible !== visible && modalDidClose) {
      modalDidClose();
    }
  }

  render() {
    const { className, onClose, children } = this.props;

    const componentClasses = classNames(
      styles.ModalBase,
      this.props.baseModalClass ? this.props.baseModalClass : ''
    );

    return (
      <div className={componentClasses} onKeyPress={this.escfunction}>
        <div className={styles.BackgroundOverlay} onClick={onClose}></div>
        <div className={classNames(styles.Content, { [className]: className })}>
          {onClose && (
            <MdClose
              className={styles.CloseIcon}
              onClick={onClose}
              style={{ color: '#0054A4' }}
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key == 'Enter') onClose();
              }}
            />
          )}
          {children}
        </div>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default ModalBase;
